/* Cantinho LimArt — reveal on scroll + upsell lâmpada no PDP + barra de portes grátis */
(function () {
  document.documentElement.classList.add('lm-js');

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lm-reveal:not(.is-in), .lm-reveal-scale:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  } else { initReveal(); }
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });

  /* ---------- Upsell: adiciona a lâmpada antes do candeeiro ---------- */
  var BYPASS = 'lmUpsellDone';

  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var pfc = form.closest('product-form-component');
    if (!pfc) return;
    var scope = pfc.closest('.product-information, .shopify-section') || document;
    var box = scope.querySelector('[data-lm-upsell] input[type="checkbox"]');
    if (!box || !box.checked) return;

    if (form.dataset[BYPASS] === '1') { delete form.dataset[BYPASS]; return; }

    event.preventDefault();
    event.stopImmediatePropagation();

    var qtyInput = form.querySelector('input[name="quantity"]') || pfc.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    var variantId = box.value;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty }] })
    })
      .catch(function () {})
      .then(function () {
        form.dataset[BYPASS] = '1';
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
  }, true);

  /* ---------- Barra de progresso: portes grátis ----------
     Insere-se antes dos totais no carrinho (drawer e página)
     e volta a aparecer sempre que o tema re-renderiza o carrinho.
     Para mudar o valor: FSB_THRESHOLD (em cêntimos). */
  var FSB_COUNTRY = (window.Shopify && window.Shopify.country) || 'PT';
  var FSB_THRESHOLD = FSB_COUNTRY === 'PT' ? 8000 : 12000; // PT 80,00 € · UE 120,00 €
  var FSB_TXT = {
    pt: { left: 'Faltam {x} para teres <strong>portes grátis</strong>', done: '🎉 Tens <strong>portes grátis</strong>!' },
    en: { left: 'Add {x} more for <strong>free shipping</strong>', done: '🎉 You’ve unlocked <strong>free shipping</strong>!' },
    fr: { left: 'Plus que {x} pour la <strong>livraison offerte</strong>', done: '🎉 La <strong>livraison est offerte</strong> !' },
    de: { left: 'Noch {x} bis zum <strong>kostenlosen Versand</strong>', done: '🎉 <strong>Kostenloser Versand</strong> freigeschaltet!' }
  };

  (function freeShippingBar() {
    var lang = (document.documentElement.lang || 'pt').slice(0, 2).toLowerCase();
    var txt = FSB_TXT[lang] || FSB_TXT.pt;
    var locale = lang === 'pt' ? 'pt-PT' : lang;
    var total = null;
    var busy = false;
    var pending = false;
    var timer = null;

    var css = document.createElement('style');
    css.textContent =
      '.lm-fsb{width:100%;font-family:var(--lm-sans,inherit);font-size:13px;color:var(--lm-ink,#3a382e);margin:0 0 4px}' +
      '.lm-fsb__msg{margin:0 0 8px;line-height:1.4}.lm-fsb__msg strong{color:var(--lm-sage-dark,#5f6b4b);font-weight:600}' +
      '.lm-fsb__track{height:6px;border-radius:999px;background:var(--lm-line,#ddd6c3);overflow:hidden}' +
      '.lm-fsb__fill{height:100%;border-radius:999px;background:var(--lm-sage,#8a9873);transition:width .5s ease;width:0}';
    document.head.appendChild(css);

    function money(cents) {
      try { return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(cents / 100); }
      catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
    }

    function render(bar) {
      if (total === null) return;
      var left = Math.max(0, FSB_THRESHOLD - total);
      var pct = Math.min(100, Math.round((total / FSB_THRESHOLD) * 100));
      bar.querySelector('.lm-fsb__msg').innerHTML = left > 0 ? txt.left.replace('{x}', money(left)) : txt.done;
      bar.querySelector('.lm-fsb__fill').style.width = pct + '%';
      bar.setAttribute('aria-valuenow', String(pct));
    }

    function ensureBars() {
      var targets = document.querySelectorAll('.cart-totals');
      targets.forEach(function (t) {
        var prev = t.previousElementSibling;
        if (prev && prev.classList && prev.classList.contains('lm-fsb')) { render(prev); return; }
        var bar = document.createElement('div');
        bar.className = 'lm-fsb';
        bar.setAttribute('role', 'progressbar');
        bar.setAttribute('aria-valuemin', '0');
        bar.setAttribute('aria-valuemax', '100');
        bar.innerHTML = '<p class="lm-fsb__msg"></p><div class="lm-fsb__track"><div class="lm-fsb__fill"></div></div>';
        t.parentNode.insertBefore(bar, t);
        render(bar);
      });
    }

    function refresh() {
      if (busy) { pending = true; return; }
      busy = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { total = c.total_price; ensureBars(); })
        .catch(function () {})
        .then(function () { busy = false; if (pending) { pending = false; schedule(); } });
    }

    function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 250); }

    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var n = muts[i].target;
        if (n.closest && n.closest('.lm-fsb')) continue;
        if (n.closest && (n.closest('.cart-totals') || n.closest('.cart-drawer__summary') || n.closest('cart-items-component'))) { schedule(); return; }
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var a = added[j];
          if (a.nodeType === 1 && !a.classList.contains('lm-fsb') && (a.matches('.cart-totals') || a.querySelector('.cart-totals'))) { schedule(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });

    document.addEventListener('cart:update', schedule);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();
  })();
})();
